import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="">
      <div className="footer-container">
        <div className="row">
          <div className="col-md-4 pt-4 footerSec">
            <h4 className="footerTitle">Our Mission</h4><hr/>
            <p className="At-TeamX">
              At TeamX, we strive to give our clients the best
              experience possible.  We take pride in our comprehensive
              approach to development and design and place a strong
              emphasis on communication throughout the entire process.
              Your vision will always come first; we'll just help you
              get there.
            </p>
          </div>
          <div className="col-md-3 offset-md-2 pt-4 footerSec">
            <h4 className="footerTitle">Resources</h4><hr/>
            <div className="resources"><a href="/services">Services</a></div>
            <div className="resources"><a href="/about">About</a></div>
            <div className="resources"><a href="/#client">Clients</a></div>
            {/* <div className="resources"><a href="/jobs">Careers</a></div> */}
            <div className="resources"><a href="/work">Projects</a></div>
          </div>
          <div className="col-md-3 pt-4 footerSec">
            <h4 className="footerTitle">Connect</h4><hr/>
            <div className="contactInfo">info@theteamx.com</div>
            <div className="contactInfo">+1 (310) 508-0883</div>
            <div className="contactInfo">705 North Lake Adair Boulevard, Orlando Florida 32804</div>
            <p>
              <a href="https://www.facebook.com/pg/Team-X-868177566717598/about/">
                <i className="fab fa-facebook-square"></i>
              </a>
              <a href="https://twitter.com/TheTeamXadm">
                <i className="fab fa-twitter-square"></i>
              </a>
              <a href="https://www.instagram.com/theteam_x_/">
                <i className="fab fa-instagram"></i>
              </a>
            </p>
          </div>
          <div className="col-md-1"></div>
        </div>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js